import { render } from "./leastCommonAnswers.vue?vue&type=template&id=190dc72e&scoped=true"
import script from "./leastCommonAnswers.vue?vue&type=script&lang=js"
export * from "./leastCommonAnswers.vue?vue&type=script&lang=js"

import "./leastCommonAnswers.vue?vue&type=style&index=0&id=190dc72e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-190dc72e"]])

export default __exports__